import { ethers } from 'ethers';
import { Dispatch } from 'redux';
import { getWalletInfo, setCurrentChainId } from 'store/action';
import { modal } from 'components/WalletConnect';

export default async function switchChain(chainId: number, dispatch?: Dispatch) {
    if (!modal) return;
    const chain = (modal.getCaipNetworks(`eip155`)
        .find((chain: {id: number|string}) => chain.id == chainId));
    if (!chain) return;
    await modal.switchNetwork(chain);
    const modalProvider = await modal.getWalletProvider();
    if (!modalProvider) return;
    const newProvider = new ethers.providers.Web3Provider(modalProvider);
    const signer = newProvider.getSigner();
    if (dispatch) {
        dispatch(setCurrentChainId(chainId));
        dispatch(getWalletInfo({
            web3: (window as any).web3,
            metaMaskAddress: await signer.getAddress(),
            netID: await signer.getChainId(),
        }));
    }
    return signer;
}
